import { NavLink } from "react-router-dom";
import logo from "./../../assets/logo.png";

import "./Logo.css";

interface Props {
  navigateTo: string;
}

function Logo({ navigateTo }: Props) {
  return (
    <NavLink className="nav-button clickable logo" to={navigateTo}>
      <img src={logo} alt="Git Versioniser Logo" className="logo" />
    </NavLink>
  );
}

export default Logo;
